import { render, staticRenderFns } from "./ProgressBarChart.vue?vue&type=template&id=4576a758&scoped=true&"
import script from "./ProgressBarChart.vue?vue&type=script&lang=ts&"
export * from "./ProgressBarChart.vue?vue&type=script&lang=ts&"
import style0 from "./ProgressBarChart.vue?vue&type=style&index=0&id=4576a758&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4576a758",
  null
  
)

export default component.exports